module.exports = __webpack_public_path__ + "img/cantSend.7d32edec.svg";